"use strict";

import { Swiper, Navigation, Pagination, Scrollbar, Autoplay } from "swiper";
import breakpoints from "../helpers/breakpoints";

const defaultSlidesToShow       = 5;
const defaultSlidesToShowMobile = 2;
const defaultSpacingInPixels    = 16;

export const initializeCarousel = ($swiperWrapper) => {
    const swipperWrapperSelector = `.js-swiper-carousel[data-id="${$swiperWrapper.data("id")}"]`;

    let slidesToShow, slidesToShowMobile, spacing;

    try {
        slidesToShow       = parseInt($swiperWrapper.data("slides-to-show"), 10) || defaultSlidesToShow;
        slidesToShowMobile = parseInt($swiperWrapper.data("slides-to-show-mobile"), 10) || defaultSlidesToShowMobile;
        spacing            = parseInt($swiperWrapper.data("spacing"), 10) || defaultSpacingInPixels;
    } catch (e) {
        slidesToShow       = defaultSlidesToShow;
        slidesToShowMobile = defaultSlidesToShowMobile;
        spacing            = defaultSpacingInPixels;
    }

    const autoplay             = $swiperWrapper.data("autoplay");
    const autoplayDelay        = $swiperWrapper.data("autoplay-delay");
    const loopEnabled          = $swiperWrapper.data("loop-enabled");
    const navEnabled           = $swiperWrapper.data("navigation-enabled");
    const paginationEnabled    = $swiperWrapper.data("pagination-enabled");
    const scrollbarEnabled     = $swiperWrapper.data("scroll-enabled");
    const direction            = $swiperWrapper.data("direction");
    const clickableSlide       = !!$swiperWrapper.data("clickable-slide");
    const allowTouchSimulation = !!$swiperWrapper.data("allow-touch-simulation");
    const carouselModules      = [];

    if (navEnabled) {
        carouselModules.push(Navigation);
    }

    if (paginationEnabled) {
        carouselModules.push(Pagination);
    }

    if (scrollbarEnabled) {
        carouselModules.push(Scrollbar);
    }

    if (autoplay) {
        carouselModules.push(Autoplay);
    }

    return new Swiper(`${swipperWrapperSelector} .js-swiper-container`, {
        ...(autoplayDelay && Boolean(autoplay) ? {
            autoplay: {
                delay: autoplayDelay,
                pauseOnMouseEnter: true
            },
        } : {}),
        loop: Boolean(loopEnabled),
        modules: carouselModules,
        direction: direction || "horizontal",
        watchSlidesProgress: true,
        pagination: {
            el: `${swipperWrapperSelector} .js-swiper-pagination`,
            type: "bullets",
            clickable: true,
        },
        navigation: {
            nextEl: `${swipperWrapperSelector} .js-swiper-button-next`,
            prevEl: `${swipperWrapperSelector} .js-swiper-button-prev`,
        },
        scrollbar: {
            el: `${swipperWrapperSelector} .js-swiper-scrollbar`,
        },
        slideToClickedSlide: clickableSlide,
        slidesPerView: slidesToShowMobile,
        spaceBetween: spacing,
        simulateTouch: allowTouchSimulation && allowTouchSimulation == true ? true : false,
        breakpoints: {
            [breakpoints.md]: {
                slidesPerView: slidesToShow,
                spaceBetween: spacing,
            },
            [breakpoints.sm]: {
                slidesPerView: 1,
                spaceBetween: spacing,
                centeredSlides: true
            }
        },
    });
};

const setupSwiperCarouselConfiguration = () => {
    const carousels = $(".js-swiper-carousel");

    carousels.each(function () {
        const $swiperWrapper = $(this);

        initializeCarousel($swiperWrapper);
    });
};

const initSwiperCarousels = () => {
    setupSwiperCarouselConfiguration();
};

export default initSwiperCarousels;
